import { type Address, erc20Abi } from "viem";
import { AccountantAbi } from "../contracts/accountant-abi";
import { TellerAbi } from "../contracts/teller-abi";
import { getClient } from "../lib/client";
import type { ChainId } from "./vault-config";

type RateInQuoteWithAssetDecimalsProps = {
  assetAddress: Address;
  accountantAddress: Address;
  chainId: ChainId;
};

const getRateInQuoteWithAssetDecimals = async ({
  assetAddress,
  accountantAddress,
  chainId,
}: RateInQuoteWithAssetDecimalsProps) => {
  const client = await getClient(chainId);

  const results = await client.multicall({
    contracts: [
      {
        abi: erc20Abi,
        address: assetAddress,
        functionName: "decimals",
      },
      {
        abi: AccountantAbi,
        address: accountantAddress,
        functionName: "getRateInQuote",
        args: [assetAddress],
      },
    ],
  });
  return results;
};

type PausedStatusProps = {
  accountantAddress: Address;
  tellerAddress: Address;
  chainId: ChainId;
};

const getPausedStates = async ({
  accountantAddress,
  tellerAddress,
  chainId,
}: PausedStatusProps) => {
  const client = await getClient(chainId);

  const results = await client.multicall({
    contracts: [
      {
        abi: TellerAbi,
        address: tellerAddress,
        functionName: "isPaused",
      },
      {
        abi: AccountantAbi,
        address: accountantAddress,
        functionName: "accountantState",
      },
    ],
  });
  return results;
};

export { getPausedStates, getRateInQuoteWithAssetDecimals };
